export const GOAL_AUTO_REVIEW_EVENT_NAMES = {
  CLICKED_AUTO_REVIEW_BUTTON: 'Clicked Goal Auto-Review Button',
  CLICKED_SAVED_AUTO_REVIEW_BUTTON: 'Clicked Saved Goal Auto-Review Button',
  CLICKED_MODAL_REVIEW: 'Clicked Auto-Review Goal Modal Review Button',
  CLICKED_SAVED_MODAL_REVIEW: 'Clicked Saved Auto-Review Goal Modal Review Button',
  RECEIVED_RESULTS: 'Received Auto-Review Goal Results',
  DISMISSED_GOAL_RESULTS: 'Dismissed Auto-Review Goal Results',
  DISMISSED_SAVED_GOAL_RESULTS: 'Dismissed Saved Auto-Review Goal Results',
  DISMISSED_OBJECTIVES_RESULTS: 'Dismissed Auto-Review Objectives Results',
  DISMISSED_SAVED_OBJECTIVES_RESULTS: 'Dismissed Saved Auto-Review Objectives Results',
  CLICKED_RESULTS_ITEM_TOGGLE: 'Clicked Goal Review Results Item Toggle',
}
